import React from "react";

const FirstStepsNotLoggedIn2 = ({setShowFirstSteps}) => {
  


    return(
        <></>
    )
};
export default FirstStepsNotLoggedIn2;